import { GoogleAnalyticsService } from './analytics/google-analytics.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private ga: GoogleAnalyticsService) {
    this.ga.start();
  }

  title = 'sokrates-extracurricular';
}
